export const parseUrl = (input) => {
  try {
    return new URL(input);
  } catch {
    return null;
  }
};

const isValidImgUrl = (url) => {
  if (!url) return false;
  // shouldn't end on '/'
  if (/\/$/.test(url)) return false;
  const parsed = parseUrl(url);
  if (!parsed || !parsed.pathname || parsed.pathname === "/") return false;
  return true;
};

export const getPrettyLinkParts = ({ link, previewInfo }) => {
  if (!previewInfo) return { url: link };
  const { description, thumbnail_url, title, url } = previewInfo;
  return {
    url,
    description,
    imgUrl: isValidImgUrl(thumbnail_url) ? thumbnail_url : null,
    title,
  };
};
